
import { Table, TableBody, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Investor, Contact } from "@/types/investor";
import ContactTableRow from "./ContactTableRow";

interface ContactsTableProps {
  contacts: Contact[];
  investors: Investor[];
  getInvestorForFirm: (firmName: string) => Investor | undefined;
  isInvestorProcessed: (investor: Investor) => boolean;
}

const ContactsTable = ({ 
  contacts, 
  investors, 
  getInvestorForFirm, 
  isInvestorProcessed 
}: ContactsTableProps) => {
  return (
    <div className="rounded-md border">
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead>Contact</TableHead>
            <TableHead>Firm</TableHead>
            <TableHead>Contact Info</TableHead>
            <TableHead>Location</TableHead>
            <TableHead>Introduction Opportunities</TableHead>
            <TableHead>Actions</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {contacts.map((contact) => {
            const investor = getInvestorForFirm(contact.firmName);
            const isProcessed = investor ? isInvestorProcessed(investor) : false;
            
            return (
              <ContactTableRow
                key={contact.id}
                contact={contact}
                investor={investor}
                isProcessed={isProcessed}
              />
            );
          })}
        </TableBody>
      </Table>
    </div>
  );
};

export default ContactsTable;
